import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-5 justify-between px-7 py-3 w-full max-md:px-5" }
const _hoisted_2 = { class: "flex flex-wrap gap-10 text-sm font-medium leading-none text-gray-600" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "mt-0.5" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "flex flex-wrap gap-5 overflow-x-auto whitespace-nowrap" }
const _hoisted_7 = { class: "flex overflow-hidden items-center py-2 pr-3 pl-2 rounded-md" }
const _hoisted_8 = { class: "flex gap-3 items-center self-stretch my-auto" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "flex overflow-hidden items-center py-2 pr-3 pl-2 whitespace-nowrap rounded-md" }
const _hoisted_11 = { class: "flex gap-3 items-center self-stretch my-auto" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "flex overflow-hidden items-center py-2 pr-3 pl-2 whitespace-nowrap rounded-md" }
const _hoisted_14 = { class: "flex gap-3 items-center self-stretch my-auto" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "flex gap-4 self-start mt-1 relative" }
const _hoisted_17 = { class: "flex z-10 gap-3 items-center mr-0 font-medium" }
const _hoisted_18 = {
  key: 0,
  class: "relative w-9 h-9 overflow-hidden rounded-full flex items-center justify-center"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_21 = { class: "flex items-center justify-center w-8 h-8 bg-primary-purple text-white rounded-full" }
const _hoisted_22 = { class: "flex flex-col self-stretch my-auto" }
const _hoisted_23 = { class: "text-sm leading-none text-gray-700" }
const _hoisted_24 = { class: "text-xs leading-none text-gray-500" }
const _hoisted_25 = { class: "absolute right-0 mt-8 bg-white border border-gray-200 rounded-md shadow-lg p-3 w-auto z-50" }
const _hoisted_26 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSwitcherMenu = _resolveComponent("AppSwitcherMenu")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppSwitcherMenu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { innerHTML: _ctx.INSIGHTS_LOGO_ICON }, null, 8, _hoisted_5)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-lg font-semibold text-gray-800" }, "Expert Insights", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_BaseButton, {
              type: "button",
              class: "flex gap-2",
              onClick: _ctx.navigateToSearch
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: _ctx.INSIGHTS_SEARCH_ICON,
                  class: _normalizeClass([{
                  'text-primary-purple': _ctx.activeTab === 'search',
                  'text-gray-500': _ctx.activeTab !== 'search',
                }, "w-5 h-5"])
                }, null, 10, _hoisted_9),
                _createElementVNode("span", {
                  class: _normalizeClass(["self-stretch my-auto", {
                  'text-primary-purple': _ctx.activeTab === 'search',
                  'text-gray-600': _ctx.activeTab !== 'search',
                }])
                }, " Search ", 2)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_BaseButton, {
              type: "button",
              class: "flex gap-2",
              onClick: _ctx.navigateToWatchlist
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: _ctx.WATCHLIST_ICON,
                  class: _normalizeClass([{
                  'text-primary-purple': _ctx.activeTab === 'watchlist',
                  'text-gray-500': _ctx.activeTab !== 'watchlist',
                }, "w-5 h-5"])
                }, null, 10, _hoisted_12),
                _createElementVNode("span", {
                  class: _normalizeClass(["self-stretch my-auto", {
                  'text-primary-purple': _ctx.activeTab === 'watchlist',
                  'text-gray-600': _ctx.activeTab !== 'watchlist',
                }])
                }, " Watchlist ", 2)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_BaseButton, {
              type: "button",
              class: "flex gap-2",
              onClick: _ctx.navigateToTrends
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: _ctx.TRENDS_ICON,
                  class: _normalizeClass([{
                  'text-primary-purple': _ctx.activeTab === 'trends',
                  'text-gray-500': _ctx.activeTab !== 'trends',
                }, "w-5 h-5"])
                }, null, 10, _hoisted_15),
                _createElementVNode("span", {
                  class: _normalizeClass(["self-stretch my-auto", {
                  'text-primary-purple': _ctx.activeTab === 'trends',
                  'text-gray-600': _ctx.activeTab !== 'trends',
                }])
                }, " Trends ", 2)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", {
        class: "flex",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
        id: "userProfileInsights"
      }, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.userStore.profilePicture)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("img", {
                  loading: "lazy",
                  src: _ctx.profilePictureUrl,
                  alt: "User profile",
                  class: "w-full h-full object-cover"
                }, null, 8, _hoisted_19),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-0" }, null, -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.initials()), 1)
              ])),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.userStore.firstName) + " " + _toDisplayString(_ctx.userStore.lastName), 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.userStore.email), 1)
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "self-start text-xs font-black leading-none text-violet-600" }, null, -1))
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_BaseButton, {
            type: "button",
            class: "w-full text-left flex items-center gap-2",
            onClick: _ctx.goToAccount
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.PERSON_ICON,
                class: "text-gray-500"
              }, null, 8, _hoisted_27),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-gray-500 font-sans text-sm font-medium leading-6" }, " Account ", -1))
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_BaseButton, {
            type: "button",
            class: "w-full text-left flex items-center gap-2 logout-btn",
            onClick: _ctx.logout
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.LOGOUT_ICON,
                class: "text-red-600 ml-1"
              }, null, 8, _hoisted_28),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-gray-500 font-sans text-sm font-medium leading-6" }, " Logout ", -1))
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.showDropdown]
      ])
    ])
  ]))
}